import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { GasPumpIcon, WarningIcon, CaretRightIcon } from "@phosphor-icons/react";

/**
 * Small dashboard banner shown when today's fuel-price sheet hasn't been
 * uploaded yet. Silent while the sheet is fresh — appears on missed uploads
 * so dispatchers don't route on stale rates.
 */
export default function FuelUploadNudge() {
  const [state, setState] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/fuel/prices");
        setState(data);
      } catch { /* ignore */ }
    })();
  }, []);

  if (!state || !state.stale) return null;
  const never = !state.latest_effective_from;

  return (
    <Link
      to="/fuel-prices"
      className="flex items-center gap-3 bg-amber-50 border-l-4 border-amber-500 rounded-sm px-4 py-3 hover:bg-amber-100 transition-colors"
      data-testid="dashboard-fuel-nudge"
    >
      <div className="w-9 h-9 rounded-sm bg-amber-500 text-white flex items-center justify-center flex-shrink-0">
        <GasPumpIcon size={16} weight="bold" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-1.5 font-display font-black text-sm tracking-tight text-amber-900">
          <WarningIcon size={14} weight="fill" />
          {never ? "No fuel-price sheet uploaded yet" : `Fuel prices are stale (${state.days_stale} day${state.days_stale !== 1 ? "s" : ""} old)`}
        </div>
        <div className="text-xs text-amber-800 mt-0.5">
          {never
            ? "Upload today's rate sheet to unlock the cheapest-fuel view for your dispatchers."
            : `Latest sheet on file: ${state.latest_effective_from}. Upload today's (${state.today}) rate sheet to refresh.`}
        </div>
      </div>
      <div className="flex items-center gap-1 text-xs font-bold text-amber-800 flex-shrink-0">
        Go to Fuel Prices <CaretRightIcon size={12} weight="bold" />
      </div>
    </Link>
  );
}
